import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

import { AffLinkWithRevenue } from './AffLink'
import { CouponWithPayments } from './Coupon'

export enum PaymentTypeEnum {
  Coupon = 'Coupon',
  Shipments = 'Shipments',
  Giftcard = 'Giftcard',
  ShippingCost = 'ShippingCost',
}

export enum AffInvoiceStatusEnum {
  Pending = 'pending',
  Received = 'received',
  NotNeeded = 'not_needed',
}

export enum AffPlatformEnum {
  Instagram = 'instagram',
  Tiktok = 'tiktok',
  Blog = 'blog',
  Youtube = 'youtube',
  Facebook = 'facebook',
  Other = 'other',
}

export type AffPlatformEntry = {
  name: string
  url: string
}

export interface AffPayment {
  type: PaymentTypeEnum
  date: string
  payment: string
  description?: string
  campaignId?: string
  invoiceStatus?: AffInvoiceStatusEnum
}

export interface Affiliate {
  affLinks: { code: string }[]
  user: {
    name: string
    email: string
    familyName: string
  }
  rev: number
  pkgIncomeOffset: number
  couponIncomeOffset: number
  isOnHold?: boolean
  registeredUsers: number
  paymentGiftCards: number
  paymentsHistory: AffPayment[]
  id: string
  userId: string
  updatedAt: string
  createdAt: string
  platforms?: AffPlatformEntry[]
  automatedEmailsEnabled?: boolean
}

export interface AffiliateOrdersBreakdownRow {
  id: string
  country: PkgWarehouse
  storeName: string
  totalUses: number
}

export interface AffiliateBrandOrderRow {
  brand: string
  value: number
}

export interface AffiliateCustomerMetric {
  current: number
  previous: number
}

export interface AffiliateCustomerMetrics {
  avgCustomerValue: AffiliateCustomerMetric
  returningCustomersRate: AffiliateCustomerMetric
  avgOrdersPerCustomer: AffiliateCustomerMetric
}

export interface AffUserData extends Affiliate {
  coupons: CouponWithPayments[]
  pkgIncome: number
  affLinks: AffLinkWithRevenue[]
  ordersBreakdown: AffiliateOrdersBreakdownRow[]
  ordersByBrand: AffiliateBrandOrderRow[]
  customerMetrics: AffiliateCustomerMetrics
}
